"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _CodeSplitEnvWrapper = _interopRequireDefault(require("pricing-pages-unified-ui/components/CodeSplitEnvWrapper"));

var _Editions = require("self-service-api/constants/Editions");

var _MarketingContactsSelectors = require("../../selectors/MarketingContactsSelectors");

var SuiteTilesCTAsContainer = function SuiteTilesCTAsContainer(props) {
  var nonMerchandiseIdProduct = "growth" + props.edition;
  var isInMCBeta = (0, _reactRedux.useSelector)(_MarketingContactsSelectors.isInMCBetaSelector);

  if (isInMCBeta) {
    nonMerchandiseIdProduct = nonMerchandiseIdProduct + "-mc";
  }

  if (props.isCovidPromo && props.edition === _Editions.STARTER) {
    nonMerchandiseIdProduct = nonMerchandiseIdProduct + "-covid";
  }

  return _react.default.createElement(_CodeSplitEnvWrapper.default, {
    authedComponentLoader: function authedComponentLoader() {
      return import(
      /* webpackChunkName: "authed-chunk" */
      "pricing-pages-unified-ui/components/growth-suite-page/SuiteTileAuthedCTAs");
    },
    publicComponentLoader: function publicComponentLoader() {
      return import(
      /* webpackChunkName: "public-chunk" */
      "pricing-pages-unified-ui/components/public-only/PublicPurchaseMotionButton");
    },
    authedComponentProps: Object.assign({}, props),
    publicComponentProps: {
      use: 'primary',
      nonMerchandiseIdProduct: nonMerchandiseIdProduct,
      sourceId: 'pricing-hero',
      dtbSource: "pricing-page|growthsuite|" + props.edition
    }
  });
};

SuiteTilesCTAsContainer.propTypes = {
  edition: _propTypes.default.string.isRequired,
  isCovidPromo: _propTypes.default.bool
};
var _default = SuiteTilesCTAsContainer;
exports.default = _default;
module.exports = exports.default;